import { PAYMENT_DUE_DATE_TYPES } from 'settings/constants/billing'
import T from 'T'
import { getOrdinal } from 'utils/day'

export const PAYMENT_TERMS = {
  DUE_ON_RECEIPT: 'Due on Receipt',
  NET: 'Net',
}

export const PAYMENT_TERMS_LABELS = {
  DUE_ON_RECEIPT: 'Due on Receipt',
  NET: 'Net [X] Days',
}

export const PAYMENT_TERMS_OPTIONS = [
  { label: PAYMENT_TERMS_LABELS.DUE_ON_RECEIPT, value: PAYMENT_TERMS.DUE_ON_RECEIPT },
  { label: PAYMENT_TERMS_LABELS.NET, value: 'Net' },
]

export const PAYMENT_TERMS_TRIGGER_TYPES = {
  INDIVIDUAL: 'Individual',
  BILLING_PROFILE: 'BillingProfile',
}

export const getDayOfMonthOptions = () => Array.from({ length: 31 }, (_, i) => ({ value: i + 1, label: `${i + 1}${getOrdinal(i + 1)}` }))

export const getShortMonthClampInfo = day => {
  const numericDay = Number(day)
  if (numericDay === 31) return T.SHORT_MONTH_CLAMP_INFO
  if (numericDay === 30 || numericDay === 29) return T.FEBRUARY_CLAMP_INFO
  return ''
}

export const getPaymentDueDateText = (paymentDueDateType, paymentDayOfMonth, terms, interval) => {
  if (paymentDueDateType === PAYMENT_DUE_DATE_TYPES.SPECIFIC_DAY_OF_MONTH && paymentDayOfMonth) {
    return `Specific date: ${paymentDayOfMonth}${getOrdinal(paymentDayOfMonth)}`
  }
  // Fall back to Net X / Due on Receipt display
  if (!terms) return ''
  if (terms === 'Due on Receipt') return terms
  return `${terms} ${interval || ''}`.trim()
}

const { BILLING_PROFILE } = PAYMENT_TERMS_TRIGGER_TYPES

export const getTriggerTypeText = type => {
  if (type === BILLING_PROFILE) {
    return 'in Settings / Customer Billing Profiles'
  }

  return ''
}
